module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/book1"
    }
  }, [_vm._v("Twisted")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1"
    }
  }, [_vm._v("Gaia")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_vm._v("The High School Circle")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part2"
    }
  }, [_vm._v("Gaia")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch02"
    }
  }, [_vm._v("Painfully Beautiful")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part3"
    }
  }, [_vm._v("Ed")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch03"
    }
  }, [_vm._v("The Gaia Flu")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Numbering The Dead")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chalk")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sam")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Connection")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tom Moore")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Genuine Monsters")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Simple Job")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stranger")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("David")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Double Dare")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gentleman")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Time to Die")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gaia")])]), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/book2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kiss")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gaia")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Color of Fear")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sam")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hell Hath no Fury . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mary Moss")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" . . . Like A Woman Scorned")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gaia")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Reason to Stay")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fun For A Change")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ed")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Too Nice")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pennsylvania Station")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gaia")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not A Penny")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Freedom/Nothingness")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Color of Love")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heather")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hunger")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sam")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gaia")])]), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/book3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Payback")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gaia")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Think About Sam")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tom Moore")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Still no Call")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Romeo")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gaia The Brave")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ready and Willing")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Romeo")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inconspicuous")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tired Heather")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Romeo")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Indispensable")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heather")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vulnerable")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Romeo")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Damn Scary")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Attack")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gaia")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miss Popularity")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sex Ring")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation Exposure")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gaia")])]), _vm._v(" "), _c('p', {
    staticClass: "FMHs1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Her Kind of Game")])]), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About The Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fdfccb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/cont.vue
// module id = 63
// module chunks = 0